// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/holidays",
  ListShort: "/pyr/holidays/short",
  Create: "/pyr/holidays",
  Update: "/pyr/holidays",
};
